export const COOKIE_NAME_AUTH_TOKEN = 'authToken';
